import chartNames from "./chartNames";
import dashboardSections from "../dashboard/dashboardSections";

const eventChartsGroups = {
  [dashboardSections.OVERVIEW]: [
    chartNames.PAGE_LOADS,
    chartNames.AVG_PAGE_LOAD_SPEED,
    chartNames.IQOS_DEVICE_USAGE,
    chartNames.IQOS_DEVICE_CONNECTIONS_COUNT,
    chartNames.CONNECTION_TIME
  ],
  [dashboardSections.FIRMWARE]: [
    chartNames.FWU_STATISTICS,
    chartNames.FWU_PERFORMANCE,
    chartNames.FWU_ERRORS,
    chartNames.FWU_COUNT,
    chartNames.RECONNECTION_TIME_DURING_FWU
  ],
  [dashboardSections.DIAGNOSTIC]: [
    chartNames.DIAGNOSTICS_PERFORMANCE,
    chartNames.AD_STATISTICS,
    chartNames.AD_COUNT,
    chartNames.DIAGNOSTICS_ERRORS_READING_PERFOMANCE,
  ],
  [dashboardSections.SETTINGS]: [
    chartNames.SETTING_USAGE,
    chartNames.SETTING_PERFOMANCE,
  ],
  [dashboardSections.BATTERY_HEALTH]: [
    chartNames.BATTERY_HEALTH_STATISTICS,
    chartNames.BATTERY_HEALTH_PERFORMANCE
  ]
};

export default eventChartsGroups;
